import { systemColor, white } from "../../../config/ColorObj";

/**
 * Inline style objects for the native <table> used in StockHolderTargetEdit.
 * Kept outside components so the objects are created once (not on every render).
 */
const tableStyles = {
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "0.8125rem",
        fontFamily: "inherit",
    },

    th: {
        padding: "6px 10px",
        backgroundColor: systemColor,
        color: white,
        borderBottom: "2px solid #e0e0e0",
        borderRight: "1px solid #e0e0e0",
        textAlign: "center",
        fontWeight: 600,
        whiteSpace: "nowrap",
        minWidth: 80,
        position: "sticky",
        top: 0,
        zIndex: 1,
    },

    td: {
        padding: "4px 8px",
        borderBottom: "1px solid #eeeeee",
        borderRight: "1px solid #eeeeee",
        borderLeft: "1px solid #eeeeee",
        textAlign: "left",
        verticalAlign: "middle",
    },

    tdCenter: {
        padding: "4px 8px",
        borderBottom: "1px solid #eeeeee",
        borderRight: "1px solid #eeeeee",
        borderLeft: "1px solid #eeeeee",
        textAlign: "center",
        verticalAlign: "middle",
    },

    tdRight: {
        padding: "4px 8px",
        borderBottom: "1px solid #eeeeee",
        borderRight: "1px solid #eeeeee",
        textAlign: "right",
        verticalAlign: "middle",
        fontWeight: 500,
    },

    input: {
        width: 80,
        padding: "3px 6px",
        fontSize: "0.8125rem",
        // border: "1px solid #bdbdbd",
        // borderRadius: 4,
        // outline: "none",
        fontFamily: "inherit",
        textAlign: "right",
        // boxSizing: "border-box",
    },
};

export default tableStyles;